/* Border Tuning — Dyno Tune routing.
 * Ensures every path to a Dyno Tune funnels into the dedicated dyno booking
 * page (/pages/dyno-tuning) with the vehicle preselected, so customers always
 * go through the full booking flow (health check, Calendly, deposit/full) and
 * never check out a Dyno Tune variant from a product or collection card.
 *
 * Covers:
 *  1. Dyno booking page: reads ?vehicle=<handle> and preselects make/model/series.
 *  2. Vehicle product page: intercepts the "Dyno Tune" workshop popup confirm
 *     button and any #dyno-tune deep-link, redirecting to the booking page.
 */
(function () {
  'use strict';

  var path = (window.location.pathname || '');

  // Match locale-prefixed paths too (e.g. /en/products/..).
  var isDynoPage = /\/pages\/dyno-tuning\/?$/.test(path);
  var productMatch = path.match(/\/products\/([^\/?#]+)/);

  // ---- 1. Dyno booking page: preselect the vehicle from ?vehicle= --------
  if (isDynoPage) {
    injectVehicleHandleIntoCartAdds();
    var handleParam = null;
    try {
      handleParam = new URLSearchParams(window.location.search).get('vehicle');
    } catch (e) { /* no-op */ }
    if (handleParam) {
      preselectVehicle(handleParam);
    }
    return;
  }

  // ---- 2. Vehicle product page: route Dyno Tune selections to booking ----
  if (productMatch) {
    var handle = productMatch[1];

    // a) Arrived via a "Dyno Tune" deep link (e.g. collection card -> #dyno-tune).
    var hash = (window.location.hash || '').replace('#', '').toLowerCase();
    if (hash === 'dyno-tune' || hash === 'dyno') {
      window.location.replace('/pages/dyno-tuning?vehicle=' + encodeURIComponent(handle));
      return;
    }

    // b) User selected the "Dyno Tune" card and confirmed the workshop popup.
    //    Intercept in the capture phase so the product form's own handler
    //    (which would keep the dyno variant selectable for checkout) never runs.
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('#bt-dyno-popup-confirm') : null;
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = '/pages/dyno-tuning?vehicle=' + encodeURIComponent(handle);
    }, true);
  }

  // ---- Preselect helper --------------------------------------------------
  // Drives the booking finder's own selects using its own data, so we don't
  // duplicate the vehicle list here. Each Series/Engine option's value is the
  // product handle, so we walk make -> model until the matching handle appears.
  function preselectVehicle(handle) {
    var tries = 0;
    var timer = setInterval(function () {
      var mk = document.getElementById('bt-db-make');
      var md = document.getElementById('bt-db-model');
      var vr = document.getElementById('bt-db-var');

      // Wait until the booking script has populated the Make dropdown.
      if (!mk || !md || !vr || mk.options.length <= 1) {
        if (++tries > 60) clearInterval(timer);
        return;
      }
      clearInterval(timer);

      for (var i = 1; i < mk.options.length; i++) {
        mk.value = mk.options[i].value;
        mk.dispatchEvent(new Event('change'));

        for (var j = 1; j < md.options.length; j++) {
          md.value = md.options[j].value;
          md.dispatchEvent(new Event('change'));

          for (var k = 1; k < vr.options.length; k++) {
            if (vr.options[k].value === handle) {
              vr.value = handle;
              vr.dispatchEvent(new Event('change'));
              // Bring the booking form into view for context.
              var sec = document.getElementById('bt-booking');
              if (sec && sec.scrollIntoView) {
                sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
              return;
            }
          }
        }
      }
      // Handle not found in the list — leave the finder untouched.
    }, 100);
  }

  // ---- Cart-add injector -------------------------------------------------
  // The booking form adds the imageless Dyno Health Check product for the
  // health-check / re-tune / deposit options, carrying only a human-readable
  // "Vehicle" property. We add a hidden "_vehicle_handle" property (read from
  // the finder's own Series select, whose value is the product handle) so the
  // cart can show the matching vehicle image. Done at the network layer to
  // avoid touching the booking template.
  function injectVehicleHandleIntoCartAdds() {
    if (window.__btDynoFetchPatched) return;
    var origFetch = window.fetch;
    if (typeof origFetch !== 'function') return;
    window.__btDynoFetchPatched = true;
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        if (url.indexOf('/cart/add') !== -1 && init && typeof init.body === 'string') {
          var vr = document.getElementById('bt-db-var');
          var handle = vr && vr.value;
          if (handle) {
            var data = JSON.parse(init.body);
            var items = data.items || (data.id ? [data] : null);
            if (items) {
              items.forEach(function (it) {
                it.properties = it.properties || {};
                if (!it.properties['_vehicle_handle']) {
                  it.properties['_vehicle_handle'] = handle;
                }
              });
              init.body = JSON.stringify(data);
            }
          }
        }
      } catch (e) { /* fall through to the original fetch */ }
      return origFetch.apply(this, arguments);
    };
  }
})();
